<template>
  <hm-content title="数据概况">
    <div>
      <div style="margin-left: auto;">
        <el-radio-group  class="mr10" v-model="dateValue" @change="dateSwitch">
          <el-radio-button label="yesterday">昨天</el-radio-button>
          <el-radio-button label="aWeekAgo">过去7天</el-radio-button>
          <el-radio-button label="aMonthAgo">过去30天</el-radio-button>
        </el-radio-group>
        <el-date-picker
            clearable
            :default-time="['00:00:00', '23:59:59']"
            v-model="timeArray"
            type="datetimerange"
            align="right"
            start-placeholder="请选择开始时间"
            end-placeholder="请选择结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            class="mr10"
            @change="timeArrayChange"
        ></el-date-picker>
      </div>
    </div>
    <div class="flex overflowAuto">

      <div class="box-offline">
        <div class="title">
          加购概况
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="cartTip !== ''"
          >
            <div v-html="cartTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <div class="ft">
            <div>加购人数</div>
            <div class="ft-value">{{addCartNumber}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{memberPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>加购商品件数</div>
            <div class="ft-value">{{addCartGoodsNumber}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{goodsPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>访问-加购转化率</div>
            <div class="ft-value">{{visitTransferPer}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{transferPercentage}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="cartData"
              :settings="cartDataLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
      <div class="box-offline" style="margin-left: -20px">
        <div class="title">
          下单概况
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="orderTip !== ''"
          >
            <div v-html="orderTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <div class="ft">
            <div>下单金额(元)</div>
            <div class="ft-value">{{payAmount}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{payAmountPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>下单人数</div>
            <div class="ft-value">{{payMemberNumber}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{payMemberPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>下单订单数</div>
            <div class="ft-value">{{payOrderNumber}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{payOrderPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>下单商品件数</div>
            <div class="ft-value">{{payGoodsNumber}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{payGoodsPercentage}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="payData"
              :settings="payLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
      <div class="box-offline" style="margin-left: 60px">
        <div class="title">
          退款概况
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="refundTip !== ''"
          >
            <div v-html="refundTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <div class="ft">
            <div>成功退款金额(元)</div>
            <div class="ft-value">{{refundAmount}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{refundAmountPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>成功退款人数</div>
            <div class="ft-value">{{refundMemberNumber}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{refundMemberPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>成功退款率</div>
            <div class="ft-value">{{refundRatio}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{refundPercentage}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="refundData"
              :settings="refundLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
    </div>
    <div class="flex overflowAuto">
      <div class="box-offline" >
        <div class="title">
          会员概况
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="memberTip !== ''"
          >
            <div v-html="memberTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <div class="ft">
            <div>累计会员数</div>
            <div class="ft-value">{{addUpMemberNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{addUpMemberNumPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>新增会员数</div>
            <div class="ft-value">{{newAddMemberNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{newAddMemberNumPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>升级会员数</div>
            <div class="ft-value">{{openPlusMemberNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{openPlusMemberNumPercentage}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="memberData"
              :settings="memberLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
      <div class="box-offline" style="margin-left: -20px">
        <div class="title">
          会员活跃
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="memberActiveTip !== ''"
          >
            <div v-html="memberActiveTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <div class="ft">
            <div>访问会员数</div>
            <div class="ft-value">{{visitMemberNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{visitMemberNumPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>领券会员数</div>
            <div class="ft-value">{{getCouponMemberNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{getCouponMemberNumPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>加购会员数</div>
            <div class="ft-value">{{addCartMemberNumber}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{addCartMemberNumberPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>成交会员数</div>
            <div class="ft-value">{{payMemberNumber}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{payMemberNumberPercentage}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="memberActivityData"
              :settings="memberActivityLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
      <div class="box-offline" style="margin-left: -20px">
        <div class="title">
          分销会员概况
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="distributionMemberTip !== ''"
          >
            <div v-html="distributionMemberTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <div class="ft">
            <div>累计分销员数</div>
            <div class="ft-value">{{totalShareMemberNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{shareMemberNumPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>分销员成交金额(元)</div>
            <div class="ft-value">{{paySuccessShareMemberPrice}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{paySuccessShareMemberPricePercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>分销员成交客户数</div>
            <div class="ft-value">{{paySuccessShareMemberNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{paySuccessShareMemberNumPercentage}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="externalMemberData"
              :settings="externalMemberDataLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
    </div>
    <div class="flex overflowAuto">
      <div class="box-offline" style="margin-left: -20px">
        <div class="title">
          分销成交概况
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="distributionOrderTip !== ''"
          >
            <div v-html="distributionOrderTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <div class="ft">
            <div>分销支付金额(元)</div>
            <div class="ft-value">{{totalCommissionMoney}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{commissionMoneyPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>分销支付件数</div>
            <div class="ft-value">{{paySuccessShareGoodsNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{paySuccessShareGoodsNumPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>分销推广佣金(元)</div>
            <div class="ft-value">{{paySuccessShareGoodsPrice}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{paySuccessShareGoodsPricePercentage}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="shareCommissionData"
              :settings="shareCommissionDataLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
      <div class="box-offline" style="margin-left: -20px">
        <div class="title">
          毛利额
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="grossProfitTip !== ''"
          >
            <div v-html="grossProfitTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <div class="ft">
            <div>毛利额(元)</div>
            <div class="ft-value">{{grossProfitValue}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{grossProfitPercentage}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="grossProfitData"
              :settings="grossProfitLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
      <div class="box-offline" style="margin-left: -20px">
        <div class="title">
          毛利率
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="grossMarginTip !== ''"
          >
            <div v-html="grossMarginTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <div class="ft">
            <div>毛利率</div>
            <div class="ft-value">{{grossMarginValue}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{grossMarginPercentage}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="grossMarginData"
              :settings="grossMarginLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
    </div>
    <div class="flex overflowAuto">
      <div class="box-offline" style="margin-left: -20px">
        <div class="title">
          在架商品数
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="saleGoodsTip !== ''"
          >
            <div v-html="saleGoodsTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="goodsData"
              :settings="goodsLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
      <div class="box-offline" style="margin-left: -20px">
        <div class="title">
          小程序直播成交概况
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="liveTip !== ''"
          >
            <div v-html="liveTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <div class="ft">
            <div>直播访客数</div>
            <div class="ft-value">{{visitNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{visitNumPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>直播支付金额(元)</div>
            <div class="ft-value">{{livePayAmount}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{livePayAmountPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>直播支付人数</div>
            <div class="ft-value">{{payNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{payNumPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>直播支付订单数</div>
            <div class="ft-value">{{payOrderNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{payOrderNumPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>直播客单价(元)</div>
            <div class="ft-value">{{payAvg}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{payAvgPercentage}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="liveData"
              :settings="liveLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
      <div class="box-offline" style="margin-left: 60px">
        <div class="title">
          流量表现
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              v-if="dataFlowTip !== ''"
          >
            <div v-html="dataFlowTip"></div>
            <span slot="reference" class="ml10">
              <i class="el-icon-question" style="fontSize:20px"></i>
            </span>
          </el-popover>
        </div>
        <div>
          <div class="ft">
            <div>打开次数</div>
            <div class="ft-value">{{sessionCnt}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{sessionCntPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>访问次数</div>
            <div class="ft-value">{{visitPv}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{visitPvPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>	访问人数</div>
            <div class="ft-value">{{visitUv}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{visitUvPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>	新用户数</div>
            <div class="ft-value">{{visitUvNew}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{visitUvNewPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>	人均停留时长(秒)</div>
            <div class="ft-value">{{stayTimeUv}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{stayTimeUvPercentage}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>平均访问深度</div>
            <div class="ft-value">{{visitDepth}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>较前一周期</div>
                <div class="ft-item-value">{{visitDepthPercentage}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ve-line
              class="mt20"
              :data="dataFlow"
              :settings="dataFlowLine"
              :extend="shopCartDataZoom"
              :colors="colors"
          ></ve-line>
        </div>
      </div>
    </div>
    <div class="flex overflowAuto">
      <div class="box-offline" style="margin-left: -20px">
        <div class="title mb20">
          分类情况
        </div>
        <div>
          <el-table
            stripe
            border
            ref="table"
            :data="categoryList"
            style="width: 100%"
            size="small"
          >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            label="一级分类名称"
            width="100"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="price"
            label="销售金额(元)"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="percent"
            label="销售占比"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="hbPrice"
            label="销售环比"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="tbPrice"
            label="同比去年"
          >
          </el-table-column>
          </el-table>
        </div> 
      </div>
      <div class="box-offline" style="margin-left: 20px">
        <div class="title mb20">
          品牌销售额TOP50
        </div>
        <div>
          <el-table
            stripe
            border
            ref="table"
            :data="topBrandByPriceList"
            style="width: 100%"
            size="small"
          >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="price"
            label="销售金额(元)"
          >
          </el-table-column>
          </el-table>
        </div> 
      </div>
      <div class="box-offline" style="margin-left: 20px">
        <div class="title mb20">
          品牌销量TOP50
        </div>
        <div>
          <el-table
            stripe
            border
            ref="table"
            :data="topBrandByNumList"
            style="width: 100%"
            size="small"
          >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="cnt"
            label="销量(件)"
          >
          </el-table-column>
          </el-table>
        </div> 
      </div>
    </div>  
    <div class="flex overflowAuto">
      <div class="box-offline2" style="margin-left: -20px">
        <div class="title mb20">
          单品(SKU)销售额TOP100
        </div>
        <div>
          <el-table
            stripe
            border
            ref="table"
            :data="topSkuByPriceList"
            style="width: 100%"
            size="small"
          >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="商品名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="code"
            label="商品编码/条码"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="price"
            label="销售金额(元)"
          >
          </el-table-column>
          </el-table>
        </div> 
      </div>
      <div class="box-offline2" style="margin-left: 60px">
        <div class="title mb20">
          单品(SKU)销售量TOP100
        </div>
        <div>
          <el-table
            stripe
            border
            ref="table"
            :data="topSkuByNumList"
            style="width: 100%"
            size="small"
          >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="商品名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="code"
            label="商品编码/条码"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="cnt"
            label="销量(件)"
          >
          </el-table-column>
          </el-table>
        </div> 
      </div>
    </div>  

  </hm-content>
</template>

<script>
import VeLine from "v-charts/lib/line.common";
import VePie from "v-charts/lib/pie.common";
import {getLoginUser} from "@/utils/auth";
import moment from "moment";
export default {
  components: {
    VeLine,
    VePie
  },
  data() {
    return {
      timeArray: [],
      isInit: false,
      reqParams: {},
      dateValue: "yesterday",
      rptStartDate: "",
      rptEndDate: "",
      shopCardChat: {
        columns: ["dateValue", "加购人数", "加购商品件数", "访问-加购转化率"],
        rows: [
          { dateValue: "2019-1月1日", "加购人数": 123, "加购商品件数": 123, "访问-加购转化率": 123 },
          { dateValue: "2019-1月2日", "加购人数": 456, "加购商品件数": 123, "访问-加购转化率": 123 },
          { dateValue: "2019-1月3日", "加购人数": 777, "加购商品件数": 123, "访问-加购转化率": 123 },
          { dateValue: "2019-1月4日", "加购人数": 888, "加购商品件数": 123, "访问-加购转化率": 123 },
          { dateValue: "2019-1月5日", "加购人数": 999, "加购商品件数": 123, "访问-加购转化率": 123 },
          { dateValue: "2019-1月6日", "加购人数": 123, "加购商品件数": 123, "访问-加购转化率": 123 },
          { dateValue: "2019-1月7日", "加购人数": 111, "加购商品件数": 123, "访问-加购转化率": 123 }
        ]
      },
      shopCartLine: {
        labelMap: {
          timeQuantum: "日期",
          spuVisitUv: "访问人数",
          visitPv: "访问次数"
        }
      },
      shopCartDataZoom: {
        legend: {
          show: true,
          bottom: "bottom"
        }
      },
      colors: ["#43CDB7", "#B33AF7"],

      //下单
      payAmount: "",
      payAmountPercentage: "",
      payMemberNumber: "",
      payMemberPercentage: "",
      payOrderNumber: "",
      payOrderPercentage: "",
      payGoodsNumber: "",
      payGoodsPercentage: "",
      payData: {
        columns: ['date', 'payAmount', 'payMemberNumber', 'payOrderNumber', 'payGoodsNumber'],
        rows: []
      },
      payLine: {
        labelMap: {
          date: "日期",
          payAmount: "下单金额",
          payMemberNumber: "下单人数",
          payOrderNumber: "下单次数",
          payGoodsNumber: "下单商品件数"
        }
      },
      //退款
      refundAmount: "",
      refundAmountPercentage: "",
      refundMemberNumber: "",
      refundMemberPercentage: "",
      refundRatio: "",
      refundPercentage: "",
      refundData: {
        columns: ['date', 'refundAmount', 'refundMemberNumber', 'refundRatio'],
        rows: []
      },
      refundLine: {
        labelMap: {
          date: "日期",
          refundAmount: "成功退款金额",
          refundMemberNumber: "成功退款人数",
          refundRatio: "成功退款率"
        }
      },
      //直播
      visitNum: "",
      visitNumPercentage: "",
      livePayAmount: "",
      livePayAmountPercentage: "",
      payNum: "",
      payNumPercentage: "",
      payOrderNum: "",
      payOrderNumPercentage: "",
      payAvg: "",
      payAvgPercentage: "",
      liveData: {
        columns: ['date', 'visitNum', 'payAmount', 'payNum', 'payOrderNum', 'payAvg'],
        rows: []
      },
      liveLine: {
        labelMap: {
          date: "日期",
          visitNum: "直播访客数",
          payAmount: "直播支付金额",
          payNum: "直播支付人数",
          payOrderNum: "直播支付订单数",
          payAvg: "直播客单价"
        }
      },
      //在架商品
      goodsData: {
        columns: ['rptDate', 'strValue'],
        rows: []
      },
      goodsLine: {
        labelMap: {
          rptDate: "日期",
          strValue: "在架商品数"
        }
      },
      //流量表现
      sessionCnt: "",
      visitPv: "",
      visitUv: "",
      visitUvNew: "",
      stayTimeUv: "",
      visitDepth: "",
      sessionCntPercentage: "",
      visitPvPercentage: "",
      visitUvPercentage: "",
      visitUvNewPercentage: "",
      stayTimeUvPercentage: "",
      visitDepthPercentage: "",
      dataFlow: {
        columns: ['date', 'sessionCnt', 'visitPv', 'visitUv', 'visitUvNew', 'stayTimeUv', 'visitDepth'],
        rows: []
      },
      dataFlowLine: {
        labelMap: {
          date: "日期",
          sessionCnt: "打开次数",
          visitPv: "访问次数",
          visitUv: "访问人数",
          visitUvNew: "新用户数",
          stayTimeUv: "人均停留时长",
          visitDepth: "平均访问深度"
        }
      },
      //毛利额
      grossProfitValue: "",
      grossProfitPercentage: "",
      grossProfitData: {
        columns: ['date', 'strValue'],
        rows: []
      },
      grossProfitLine: {
        labelMap: {
          rptDate: "日期",
          strValue: "毛利额"
        }
      },
      //毛利率
      grossMarginValue: "",
      grossMarginPercentage: "",
      grossMarginData: {
        columns: ['date', 'strValue'],
        rows: []
      },
      grossMarginLine: {
        labelMap: {
          rptDate: "日期",
          strValue: "毛利率"
        }
      },
      //会员概况
      addUpMemberNum: "",
      addUpMemberNumPercentage: "",
      newAddMemberNum: "",
      newAddMemberNumPercentage: "",
      openPlusMemberNum: "",
      openPlusMemberNumPercentage: "",
      memberData: {
        columns: ['date', 'addUpMemberNum', 'newAddMemberNum', 'openPlusMemberNum'],
        rows: []
      },
      memberLine: {
        labelMap: {
          date: "日期",
          addUpMemberNum: "累计会员数",
          newAddMemberNum: "新增会员数",
          openPlusMemberNum: "升级会员数",
        }
      },
      //活跃会员
      visitMemberNum: "",
      visitMemberNumPercentage: "",
      getCouponMemberNum: "",
      getCouponMemberNumPercentage: "",
      addCartMemberNumber: "",
      addCartMemberNumberPercentage: "",
      memberPayNumber: "",
      payMemberNumberPercentage: "",
      memberActivityData: {
        columns: ['date', 'visitMemberNum', 'getCouponMemberNum', 'addCartMemberNumber', 'memberPayNumber'],
        rows: []
      },
      memberActivityLine: {
        labelMap: {
          date: "日期",
          visitMemberNum: "访问会员数",
          getCouponMemberNum: "领券会员数",
          addCartMemberNumber: "加购会员数",
          memberPayNumber: "成交会员数"
        }
      },
      //加购概况
      addCartNumber: "",
      memberPercentage: "",
      addCartGoodsNumber: "",
      goodsPercentage: "",
      visitTransferPer: "",
      transferPercentage: "",
      cartData: {
        columns: ['date', 'addCartMemberNumber', 'addCartGoodsNumber', 'visitTransferPer'],
        rows: []
      },
      cartDataLine: {
        labelMap: {
          date: "日期",
          addCartMemberNumber: "加购人数",
          addCartGoodsNumber: "加购商品件数",
          visitTransferPer: "访问-加购转化率",
        }
      },
      //分销会员概况
      internalShareMemberNum: "",
      totalShareMemberNum: "",
      shareMemberNumPercentage: "",
      paySuccessShareMemberNum: "",
      paySuccessShareMemberNumPercentage: "",
      paySuccessShareMemberPrice: "",
      paySuccessShareMemberPricePercentage: "",
      externalMemberData: {
        columns: ['date', 'totalShareMemberNum', 'paySuccessShareMemberNum', 'paySuccessShareMemberPrice'],
        rows: []
      },
      externalMemberDataLine: {
        labelMap: {
          date: "日期",
          totalShareMemberNum: "累计分销员数",
          paySuccessShareMemberPrice: "分销员成交金额",
          paySuccessShareMemberNum: "分销员成交客户数"
        }
      },
      //分销成交概况
      totalCommissionMoney: "",
      commissionMoneyPercentage: "",
      paySuccessShareGoodsNum: "",
      paySuccessShareGoodsNumPercentage: "",
      paySuccessShareGoodsPrice: "",
      paySuccessShareGoodsPricePercentage: "",
      shareCommissionData: {
        columns: ['date', 'totalCommissionMoney', 'paySuccessShareGoodsNum', 'paySuccessShareGoodsPrice'],
        rows: []
      },
      shareCommissionDataLine: {
        labelMap: {
          date: "日期",
          totalCommissionMoney: "分销支付金额",
          paySuccessShareGoodsNum: "分销支付件数",
          paySuccessShareGoodsPrice: "分销推广佣金"
        }
      },
      //提示
      cartTip: "",
      orderTip: "",
      refundTip: "",
      memberTip: "",
      memberActiveTip: "",
      distributionMemberTip: "",
      distributionOrderTip: "",
      grossProfitTip: "",
      grossMarginTip: "",
      saleGoodsTip: "",
      liveTip: "",
      dataFlowTip: "",
      categoryList: [],
      topBrandByPriceList: [],
      topBrandByNumList: [],
      topSkuByPriceList: [],
      topSkuByNumList: [],
    }
  },
  created() {
    this.isInit = true;
    this.query();
    this.getDataTip();
  },
  mounted() {
  },
  methods: {
    query() {
      this.reqParams = this.getReqParam();
      if (this.rptStartDate != '') {
        this.queryPayData();
        this.queryRefundData();
        this.queryLiveData();
        this.queryGoodsData();
        this.queryDataFlow();
        this.queryGrossData();
        this.queryAddGoodsData();
        this.queryMemberData();
        this.activityMember();
        this.queryShareMemberData();
        this.queryShareCommissionData();
        this.generalReportsCategory();
        this.generalReportsTopBrandByPrice();
        this.generalReportsTopBrandByNum();
        this.generalReportsTopSkuByPrice();
        this.generalReportsTopSkuByNum();
      }
    },
    async getDataTip() {
      const {code, result} = await this.$store.dispatch("dataTip", "");
      if (code === '0') {
        result.forEach(r=>{
          console.log(r);
          switch (r.k) {
            case "data_cart_tip":
              this.cartTip = r.v;
              break;
            case "data_xiadan":
              this.orderTip = r.v;
              break;
            case "data_tuikuan":
              this.refundTip = r.v;
              break;
            case "data_member":
              this.memberTip = r.v;
              break;
            case "data_liuliang":
              this.dataFlowTip = r.v;
              break;
            case "data_fenxiao":
              this.distributionMemberTip = r.v;
              break;
            case "data_fenxiaochengjiao":
              this.distributionOrderTip = r.v;
              break;
            case "data_goods":
              this.saleGoodsTip = r.v;
              break;
            case "data_huiyuanhuoyue":
              this.memberActiveTip = r.v;
              break;
            case "data_mle":
              this.grossProfitTip = r.v;
              break;
            case "data_mll":
              this.grossMarginTip = r.v;
              break;
            case "data_xcx":
              this.liveTip = r.v;
              break;
          }
        })
      }
    },
    async queryPayData() {
      this.isInit = false;
      const {code, result} = await this.$store.dispatch("queryPayData", this.reqParams);
      if (code === '0') {
        this.payAmount = result.payAmount;
        this.payAmountPercentage = result.payAmountPercentage;
        this.payMemberNumber = result.payMemberNumber;
        this.payMemberPercentage = result.payMemberPercentage;
        this.payOrderNumber = result.payOrderNumber;
        this.payOrderPercentage = result.payOrderPercentage;
        this.payGoodsNumber = result.payGoodsNumber;
        this.payGoodsPercentage = result.payGoodsPercentage;
        this.payData.rows = result.payOrderResponseList;
      }
    },
    async queryRefundData() {
      const {code, result} = await this.$store.dispatch("queryRefundData", this.reqParams);
      if (code === '0') {
        this.refundAmount = result.refundAmount;
        this.refundAmountPercentage = result.refundAmountPercentage;
        this.refundMemberNumber = result.refundMemberNumber;
        this.refundMemberPercentage = result.refundMemberPercentage;
        this.refundRatio = result.refundRatio;
        this.refundPercentage = result.refundPercentage;
        this.refundData.rows = result.refundSummaryList;
      }
    },
    async queryLiveData() {
      const {code, result} = await this.$store.dispatch("queryLiveData", this.reqParams);
      if (code === '0') {
        this.visitNum = result.visitNum;
        this.visitNumPercentage = result.visitNumPercentage;
        this.livePayAmount = result.payAmount;
        this.livePayAmountPercentage = result.payAmountPercentage;
        this.payNum = result.payNum;
        this.payNumPercentage = result.payNumPercentage;
        this.payOrderNum = result.payOrderNum;
        this.payOrderNumPercentage = result.payOrderNumPercentage;
        this.payAvg = result.payAvg;
        this.payAvgPercentage = result.payAvgPercentage;
        this.liveData.rows = result.liveSummaries;
      }
    },
    async queryGoodsData() {
      const param = JSON.parse(JSON.stringify(this.reqParams));
      param.bizType = "dailyOnShelfGoodsNumSummary";
      const {code, result} = await this.$store.dispatch("queryGoodsData", param);
      if (code === '0') {
        this.goodsData.rows = result.rptBizSummaryModelList;
      }
    },
    async queryDataFlow() {
      const {code, result} = await this.$store.dispatch("queryDataFlow", this.reqParams);
      if (code === '0') {
        this.sessionCnt = result.sessionCnt;
        this.visitPv = result.visitPv;
        this.visitUv = result.visitUv;
        this.visitUvNew = result.visitUvNew;
        this.stayTimeUv = result.stayTimeUv;
        this.visitDepth = result.visitDepth;
        this.sessionCntPercentage = result.sessionCntPercentage;
        this.visitPvPercentage = result.visitPvPercentage;
        this.visitUvPercentage = result.visitUvPercentage;
        this.visitUvNewPercentage = result.visitUvNewPercentage;
        this.stayTimeUvPercentage = result.stayTimeUvPercentage;
        this.visitDepthPercentage = result.visitDepthPercentage;
        this.dataFlow.rows = result.visitSummaries;
      }
    },
    async queryGrossData() {
      const param = JSON.parse(JSON.stringify(this.reqParams));
      param.bizTypeList = ['dailyGrossMarginSummary','dailyGrossProfitSummary',"totalShareMemberNum","paySuccessShareMemberNum","paySuccessShareMemberPrice"];
      const {code, result} = await this.$store.dispatch("queryGrossData", param);
      if (code === '0') {
        if (result.dailyGrossProfitSummary) {
          this.grossProfitValue = result.dailyGrossProfitSummary.thisTotalValue;
          this.grossProfitPercentage = result.dailyGrossProfitSummary.previousTotalPercentage;
          this.grossProfitData.rows = result.dailyGrossProfitSummary.rptBizSummaryComplexDataList;
        }
        if (result.dailyGrossMarginSummary) {
          this.grossMarginValue = result.dailyGrossMarginSummary.thisTotalAvgPercentage;
          this.grossMarginPercentage = result.dailyGrossMarginSummary.previousTotalPercentage;
          this.grossMarginData.rows = result.dailyGrossMarginSummary.rptBizSummaryComplexDataList;
        }
      }
    },
    async queryAddGoodsData() {
      const {code, result} = await this.$store.dispatch("queryAddGoodsData", this.reqParams);
      if (code === '0') {
        this.addCartNumber = result.addCartMemberNumber;
        this.memberPercentage = result.memberPercentage;
        this.addCartGoodsNumber = result.addCartGoodsNumber;
        this.goodsPercentage = result.goodsPercentage;
        this.visitTransferPer = result.visitTransferPer;
        this.transferPercentage = result.transferPercentage;
        this.cartData.rows = result.addGoodsSummaryList;
      }
    },
    async queryMemberData() {
      const {code, result} = await this.$store.dispatch("queryMemberData", this.reqParams);
      if (code === '0') {
        this.addUpMemberNum = result.addUpMemberNum;
        this.addUpMemberNumPercentage = result.addUpMemberNumPercentage;
        this.newAddMemberNum = result.newAddMemberNum;
        this.newAddMemberNumPercentage = result.newAddMemberNumPercentage;
        this.openPlusMemberNum = result.openPlusMemberNum;
        this.openPlusMemberNumPercentage = result.openPlusMemberNumPercentage;
        this.memberData.rows = result.memberSummaryList;
      }
    },
    async activityMember() {
      const {code, result} = await this.$store.dispatch("queryMemberActiveData", this.reqParams);
      if (code === '0') {
        this.visitMemberNum = result.visitMemberNum;
        this.visitMemberNumPercentage = result.visitMemberNumPercentage;
        this.getCouponMemberNum = result.getCouponMemberNum;
        this.getCouponMemberNumPercentage = result.getCouponMemberNumPercentage;
        this.addCartMemberNumber = result.addCartMemberNumber;
        this.addCartMemberNumberPercentage = result.addCartMemberNumberPercentage;
        this.memberPayNumber = result.payMemberNumber;
        this.payMemberNumberPercentage = result.payMemberNumberPercentage;
        this.memberActivityData.rows = result.memberActiveSummaryList;
      }
    },
    async queryShareMemberData() {
      const {code, result} = await this.$store.dispatch("queryShareMemberData", this.reqParams);
      if (code === '0') {
        this.internalShareMemberNum = result.internalShareMemberNum;
        this.totalShareMemberNum = result.totalShareMemberNum;
        this.shareMemberNumPercentage = result.shareMemberNumPercentage;
        this.paySuccessShareMemberNum = result.paySuccessShareMemberNum;
        this.paySuccessShareMemberNumPercentage = result.paySuccessShareMemberNumPercentage;
        this.paySuccessShareMemberPrice = result.paySuccessShareMemberPrice;
        this.paySuccessShareMemberPricePercentage = result.paySuccessShareMemberPricePercentage;
        this.externalMemberData.rows = result.shareMemberSummaryList;
      }
    },
    async queryShareCommissionData() {
      const {code, result} = await this.$store.dispatch("queryShareCommissionData", this.reqParams);
      if (code === '0') {
        this.totalCommissionMoney = result.totalCommissionMoney;
        this.commissionMoneyPercentage = result.commissionMoneyPercentage;
        this.paySuccessShareGoodsNum = result.paySuccessShareGoodsNum;
        this.paySuccessShareGoodsNumPercentage = result.paySuccessShareGoodsNumPercentage;
        this.paySuccessShareGoodsPrice = result.paySuccessShareGoodsPrice;
        this.paySuccessShareGoodsPricePercentage = result.paySuccessShareGoodsPricePercentage;
        this.shareCommissionData.rows = result.shareCommissionSummaryList;
      }
    },
    async generalReportsCategory() {
      const {code, result} = await this.$store.dispatch("generalReportsCategory", this.reqParams);
      if (code === '0') {
        this.categoryList = result;
        console.log("this.categoryList:",this.categoryList);
      }
    },
    async generalReportsTopBrandByPrice() {
      const {code, result} = await this.$store.dispatch("generalReportsTopBrandByPrice", this.reqParams);
      if (code === '0') {
        this.topBrandByPriceList = result;
        console.log("this.topBrandByPriceList:",this.topBrandByPriceList);
      }
    },
    async generalReportsTopBrandByNum() {
      const {code, result} = await this.$store.dispatch("generalReportsTopBrandByNum", this.reqParams);
      if (code === '0') {
        this.topBrandByNumList = result;
        console.log("this.topBrandByNumList:",this.topBrandByNumList);
      }
    },
    async generalReportsTopSkuByPrice() {
      const {code, result} = await this.$store.dispatch("generalReportsTopSkuByPrice", this.reqParams);
      if (code === '0') {
        this.topSkuByPriceList = result;
        console.log("this.topSkuByPriceList:",this.topSkuByPriceList);
      }
    },
    async generalReportsTopSkuByNum() {
      const {code, result} = await this.$store.dispatch("generalReportsTopSkuByNum", this.reqParams);
      if (code === '0') {
        this.topSkuByNumList = result;
        console.log("this.topSkuByNumList:",this.topSkuByNumList);
      }
    },
    getReqParam() {
      if (this.rptStartDate === "") {
        this.dateValue = "yesterday";
        this.dateSwitch()
      }
      this.reqParams = {
        storeCode: getLoginUser().storeCode,
        rptStartDate: this.rptStartDate,
        rptEndDate: this.rptEndDate
      }
      return this.reqParams;
    },
    dateSwitch() {
      const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
      const end = new Date(new Date(new Date().toLocaleDateString()).getTime() -1);
      this.timeArray = [];
      if (this.dateValue === 'yesterday') {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
      }
      if (this.dateValue === 'aWeekAgo') {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      }
      if (this.dateValue === 'aMonthAgo') {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      }
      this.rptStartDate = moment(start).format("YYYY-MM-DD HH:mm:ss");
      this.rptEndDate = moment(end).format("YYYY-MM-DD HH:mm:ss");
      if (!this.isInit) {
        this.query();
      }
    },
    timeArrayChange() {
      if (this.timeArray) {
        this.rptStartDate = this.timeArray[0];
        this.rptEndDate = this.timeArray[1];
        this.query();
      }
    }

  },
}
</script>

<style lang="scss" scoped>
.data-item {
  margin-bottom: 10px;
}
.left {
  width: 88px;
  height: 142px;
  float: left;
  .hmicon {
    font-size: 40px;
    text-align: center;
    padding-top: 40px;
    color: rgba(255, 255, 255, 1);
  }
  .tit {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    padding-top: 5px;
    text-align: center;

  }
}
.left-blue {
  background: #547DFF;
}
.left-red {
  background: #F65E6A;
}
.left-orange {
  background: #F78752;
}
.left-purple{
  background: #BF6DFF;
}
.left-sky_blue {
  background: #56B0FF;
}
.right {
  width: 1580px;
  height: 142px;
  background: #F8FAFF;
  margin-left: 88px;
}
.right-color {
  background: #FFF9F9;
}
.box-offline {
  background: #ffffff;
  padding: 20px;
  .title {
    color: #222222;
    font-weight: bold;
    width: 500px;
    &::before {
      display: inline-block;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
    }
  }
}
.box-offline2 {
  background: #ffffff;
  padding: 20px;
  .title {
    color: #222222;
    font-weight: bold;
    width: 750px;
    &::before {
      display: inline-block;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
    }
  }
}
.ft {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  padding-top: 20px;
  margin-right: 20px;
  display: inline-block;
  .ft-value {
    font-size: 24px;
    font-weight: 600;
    line-height: 33px;
    margin-top: 5px;
  }
  .ft-item {
    margin-top: 5px;
    color: #ABACAD;
    .ft-item-margin {
      margin-right: 23px;
    }
    .ft-item-value {
      color: #3E3E3F;
      margin-top: 5px;
    }
  }
}
.ft-margin {
  margin-right: 0;
}
.overflowAuto{
  overflow-x: auto; 
  white-space: nowrap;
}
</style>